import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as Actions from './store/actions';
import * as Chart from "chart.js";
import "chartjs-plugin-labels";
import classNames from 'classnames';

import { Button, Tab, Tabs, Grid, DialogTitle, DialogContent, DialogActions, Dialog, Typography, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@material-ui/core';

const styles = theme => ({

});

class StudentProgressChart extends Component {
    state = { chartReady: false }
    constructor(props) {
        super(props);
    }

    chartRef = React.createRef();

    chartHeaders = {
        student: 'Assignment and Quiz Completion',
        company: 'Company Assignment and Quiz Completion',
        admin: 'Event Completion by Company',
        dev: 'Event Completion by Company'
    }

    // This is incase we want custom filters/actions
    filterInactiveDatasets = (data) => {
        return {
            ...data,
            datasets: data.datasets.filter(d => d.Active)
        }
    }

    componentDidMount = async () => {
        await this.props.getStudentProgress(this.props.auth.user.data.auth_id);
    }

    componentWillUnmount = () => {
        this.props.resetStore();
    }

    componentDidUpdate = () => {
        if (this.props.studentProgressData.loaded) {
            if (!this.state.chartReady) {
                const myChartRef = this.chartRef.current.getContext("2d");
                new Chart(myChartRef, {
                    type: "line",
                    data: this.filterInactiveDatasets(this.props.studentProgressData[this.props.studentProgressData.choice]),
                });
                this.setState({ chartReady: true })
            }
        }
    }

    handleChoiceChange = (e) => {
        this.props.updateChoice(e.target.value)
        this.setState({ chartReady: false })
    };

    render() {
        return (
            <div style={{ padding: '5px' }}>
                <Grid container spacing={8} style={{ marginTop: '10px' }}>
                    <Grid item xs={2}></Grid>
                    <Grid item xs={8}>
                        <div style={{ width: '100%', border: '1px solid rgba(0,0,0,.125)', padding: '10px', backgroundColor: 'rgba(0,0,0,.03)' }}>
                            <Typography variant={'body1'}>{this.chartHeaders[this.props.auth.user.role]}</Typography>
                        </div>
                        <div style={{ width: '100%', borderBottom: '1px solid rgba(0,0,0,.125)', borderLeft: '1px solid rgba(0,0,0,.125)', borderRight: '1px solid rgba(0,0,0,.125)' }}>
                            <FormControl style={{ paddingLeft: '10px' }}>
                                <InputLabel id="demo-simple-select-helper-label"></InputLabel>
                                <Select
                                    labelId="demo-simple-select-helper-label"
                                    id="demo-simple-select-helper"
                                    value={this.props.studentProgressData.choice}
                                    onChange={(e) => this.handleChoiceChange(e)}
                                >
                                    <MenuItem value={'week'}>2 Weeks</MenuItem>
                                    <MenuItem value={'month'}>3 Months</MenuItem>
                                    <MenuItem value={'year'}>Year</MenuItem>
                                </Select>
                                <FormHelperText>Time Period</FormHelperText>
                            </FormControl>
                            <canvas
                                id="myChart"
                                ref={this.chartRef}
                            />
                        </div>

                    </Grid>
                </Grid>

            </div>
        )
    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getStudentProgress: Actions.getStudentProgress,
        updateChoice: Actions.updateChoice,
        resetStore: Actions.resetStore
    }, dispatch);
}

function mapStateToProps({ auth, progressApp }) {
    return {
        studentProgressData: progressApp.progress.studentProgressData,
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(StudentProgressChart)));


// WEBPACK FOOTER //
// src/main/content/progress/StudentProgressChart.js